var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 21.5719C9.6 21.5719 7.44375 20.325 6.24375 18.2438C5.03437 16.1625 5.03437 13.6781 6.24375 11.5969L11.3062 2.82188C11.6156 2.2875 12.3844 2.2875 12.6937 2.82188L17.7562 11.5969C18.9562 13.6781 18.9562 16.1625 17.7562 18.2438C16.5562 20.325 14.4 21.5719 12 21.5719ZM11.6531 5.11875L10.575 6.99375C10.2937 7.63125 9.81563 9.01875 10.2656 10.2938C10.6125 11.2781 11.4844 12.0469 12.8531 12.5625C14.8406 13.3125 16.1438 14.4281 16.7156 15.8813C16.8094 16.1156 16.8844 16.35 16.9313 16.575C17.4094 15.1688 17.2594 13.6406 16.5 12.3188L12.3469 5.11875C12.1969 4.85625 11.8031 4.85625 11.6531 5.11875ZM7.5 12.3188L8.72812 10.1813C8.775 10.3781 8.82188 10.575 8.8875 10.7719C9.39375 12.1781 10.5563 13.2375 12.3375 13.9125C13.9219 14.5125 14.9344 15.3469 15.3563 16.3969C15.8156 17.5312 15.45 18.6281 15.3281 18.9281C14.4094 19.6875 13.2469 20.1188 12 20.1188C10.125 20.1188 8.4375 19.1531 7.5 17.5219C6.5625 15.8906 6.5625 13.95 7.5 12.3188Z",
    fill: "#6FBCF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSui);
export default __webpack_public_path__ + "static/media/sui.5833ecd5fec8c7bd2b631aa23e4a0bd7.svg";
export { ForwardRef as ReactComponent };